<template src="./onlineTestStudentMarks.html"></template>

<script>
import showStatus from '../../../NetworkManager/showStatus'
import SemesterUserRepository from "../../../Repository/SemesterUser";
import UserRepository from "../../../Repository/User";
import apiV3 from "../../../NetworkManager/apiV3";
import { createExcelThroughJson, generateJsonFromExcel } from '../../../utils/excel';
export default {
  name: "onlineTestStudentMarks",
  props: [
    "prop_selectedSubject",
    "prop_selectedSubjectId",
    "prop_tabNumber",
    "prop_allSubjects",
    "prop_selectedItem"
  ],
  data() {
    return {
      testId: "",
      overallMarksHeaders: [
        { text: "Prn", value: "collegePRNNo", align: "center", width: "15%" },
        { text: "Roll No.", value: "rollNumber", align: "center", width: "15%" },
        { text: "Student Name", value: "studentName", align: "center", width: "50%" },
        { text: "Overall Marks", value: "obtainedMarks", align: "center", width: "10%" }
      ],
      questionWiseMarksHeaders: [
      { text: "Prn", value: "collegePRNNo", align: "center", width: "15%" },
        { text: "Roll No.", value: "rollNumber", align: "center", width: "15%" },
        { text: "Student Name", value: "studentName", align: "center" },
        { text: "Overall Marks", value: "obtainedMarks", align: "center", width: "10%" }
      ],
      filteredStudents: [],
      backgroundColor: "#E7E7FFCF",
      testSelection: {},
      selectedRadio: null,
      studentsForTest: [],
      selectAllStudents: false,
      userDetails: [],
      allowedStudents: [],
      overAllAnalysis: [],
      isAllocatedStudent: false,
      test: {},
      studentIds: [],
      studentAnswers: [],
      resubmissionAnswerIds: [],
      saveChanges: false,
      studentAnalysis: [],
      questions: [],
      result: null,
      studentAnswersBackdated: [],
      marksErrors: [],
      showErrors: false,
      questionWiseMarks: [],
      uploadMarksViaExcel: false,
      marksExcelFile: null,
      excelErrors: [],
      isDisabled: false
    };
  },
  async created() {
    await this.initializeTestDetails();
  },
  async activated() {
    const { basicDetails, questions } = this.$store.state.liveData.testDetailsChanged;
    if (basicDetails || questions) {
      await this.executeTestProcesses();
    }
  },
  computed: {
    processedStudentsForTest() {
      return this.studentsForTest.map((item) => {
        const newItem = { ...item };
        this.questionWiseMarksHeaders.forEach((header) => {
          if (!newItem[header.value]) {
            this.$set(newItem, header.value, { marks: 0 });
          }
        });
        return newItem;
      });
    }
  },
  methods: {

    async initializeTestDetails() {
      try {
        this.userData = this.$store.getters["user/get_userData"];
        this.selectedDepartment = this.$store.getters["liveData/get_examDepartment"];
        this.semesterUserRepositoryInstance = new SemesterUserRepository(this);
        this.userRepositoryInstance = new UserRepository(this);
        this.selectedCourseYear = this.$store.getters["liveData/get_examCourseYear"];
        this.selectedInstitute = this.$store.getters["instituteData/get_selectedInstitute"];
        this.selectedSemester = this.$store.getters["instituteData/get_selectedSemester"];
        this.testId = this.$store.getters["liveData/get_testId"];
        this.testSelection = this.$store.getters["liveData/get_selectedObjectTest"];

        await this.executeTestProcesses();
      } catch (error) {
        console.error("Error during test initialization", error);
      }
    },

    async executeTestProcesses() {
      try {
        await this.fetchTest();
        await this.getStudents();
        await this.getUsersDetails();
        await this.fetchTestAnswers();
      } catch (error) {
        console.error("Error during test processes execution", error);
      }
    },

    async downloadSampleMarksExcel() {
      const data = [];
      this.studentsForTest.forEach(stud => {
        console.log('stud', stud);
          const objToPush = {
              Name: `${stud.firstName}${stud.middleName}${stud.lastName}`,
              "Roll number": stud.rollNumber,
              "College PRN No": stud.collegePRNNo
          };
          const matchingAnswer = this.studentAnswers.find(answer => answer.studentId === stud.uId);

          if (matchingAnswer) {
              const formattedAnswers = matchingAnswer.answers.reduce((acc, answerObj) => {
                  if (answerObj.questionNumber && answerObj.outOf) {
                      const dynamicKey = `${answerObj.questionNumber}(${answerObj.outOf})`;
                      acc[dynamicKey] = answerObj.marksObtained ?? ""; // Assigning marks properly
                  }
                  return acc;
              }, {});

              Object.assign(objToPush, formattedAnswers);

              // objToPush["Obtained Marks"] = stud.obtainedMarks ?? matchingAnswer.totalMarksObtained;
          }

          this.questions.forEach(question => {
              const questionKey = `${question.questionNumber}(${question.marks})`;
              if (!(questionKey in objToPush)) {
                  objToPush[questionKey] = "";
              }
          });

          data.push(objToPush);
      });

      console.log(data);

      this.excelLink = createExcelThroughJson(data, `backdated ${this.test.data.name} test_sample`)
    },

    async handleParseMarksExcel() {
      this.questionWiseMarks = []
      const schema = {
          Sheet1: Object.create(null) // Creates a plain object without prototype
      };

      schema.Sheet1.Name = {
          validation: {
              type: 'textLength',
              required: true
          },
          variableName: 'name'
      };

      schema.Sheet1["Roll number"] = {
          validation: {
              type: 'textLength'
          },
          variableName: 'rollNumber'
      };

      schema.Sheet1["College PRN No"] = {
          validation: {
              type: 'textLength'
          },
          variableName: 'collegePRNNo'
      };

      this.questions.forEach((question) => {
          schema.Sheet1[`${question.questionNumber}(${question.marks})`] = {
              validation: {
                  type: 'textLength'
              },
              variableName: `${question.questionNumber}(${question.marks})`
          };
      });

      console.log('schema.Sheet1', schema.Sheet1);
      try {
          const res = await generateJsonFromExcel(this.marksExcelFile, schema, false);
          if (!res || !res.data || !res.data.Sheet1) {
              console.error('Error: No data extracted from Excel.');
              return;
          }

          const { Sheet1 } = res.data;
          this.studentsForTest.forEach(stud => {
              Object.values(Sheet1).forEach(record => {
                  if (
                      record.collegePRNNo === stud.collegePRNNo &&
                      record.rollNumber === stud.rollNumber
                  ) {
                      this.questions.forEach(question => {
                          const questionKey = `${question.questionNumber}(${question.marks})`;
                          if (record[questionKey] !== undefined) {
                              if (!stud[questionKey]) {
                                  stud[questionKey] = { marks: 0 };
                              }
                              stud[questionKey].marks = record[questionKey];
                          }
                      });
                      this.questionWiseMarks.push(stud)
                  }
              });
          });
          // this.questionWiseMarks = Sheet1
          this.uploadMarksViaExcel = false
          this.marksExcelFile = null
          console.log('Sheet1', this.studentsForTest);
      } catch (error) {
        this.uploadMarksViaExcel = false
          this.marksExcelFile = null
          console.error('Error while parsing marks from Excel:', error);
      }
  },

    isQuestionField(field) {
      console.log('fieldfield', field);
      const questionFields = ['collegePRNNo', 'rollNumber', 'studentName', 'status', 'obtainedMarks'];
      return questionFields.includes(field);
    },

    isOverallField(field) {
      const questionFields = ['obtainedMarks'];
      return questionFields.includes(field);
    },

    async updateQuestionMarks(item, field) {
      const index = this.questionWiseMarks.findIndex(existingItem => existingItem.uId === item.uId);
      if (index === -1) {
        this.questionWiseMarks.push(item);
      } else {
        this.questionWiseMarks[index] = item;
      }
      // console.log('updateQuestionMarks', item, field);
    },

    async updateOverallMarks(item) {
      const data = {
        studentId: item.uId,
        examId: this.test.data._id,
        totalMarksObtained: Number(item.obtainedMarks),
        passingMarks: this.test.data.passingMarks,
        answers: [],
        prnNumber: item?.prnNumber,
        rollNumber: item?.rollNumber
      }
      this.studentAnswersBackdated.push(data);
    },

    async saveBackdatedAnswers() {
      this.showErrors = false;
      this.marksErrors = []

      this.questionWiseMarks.forEach(studentObject => {
        const objectForAnswer = {};
        objectForAnswer.studentId = studentObject.uId;
        objectForAnswer.examId = this.test.data._id;
        objectForAnswer.passingMarks = this.test.data.passingMarks;
        console.log('studentObject', studentObject);
        objectForAnswer.prnNumber = studentObject?.prnNumber;
        objectForAnswer.rollNumber = studentObject?.rollNumber;

        let totalMarksObtained = 0;

        objectForAnswer.answers = [];

        let validMarks = true

        Object.keys(studentObject).forEach(key => {
          if (key.includes('(') && key.includes(')')) {
            const questionData = studentObject[key];
            if (questionData.marks > questionData.outOf) {
              console.log('here 1');
              this.marksErrors.push(`Question Marks of question number ${questionData.questionNumber} for student - ${studentObject.prnNumber || studentObject.rollNumber} cannot be greater than question marks which are ${questionData.outOf}`)
              console.log('this.marksErrors1', this.marksErrors);
              validMarks = false
            } else {
              objectForAnswer.answers.push({
                marksObtained: questionData?.marks,
                options: questionData.options,
                questionId: questionData.questionId,
                questionNumber: questionData.questionNumber,
                question: questionData.question,
                outOf: questionData.outOf,
                type: 'mcq'
              });

              const marks = questionData?.marks;
              if (!isNaN(marks)) {
                totalMarksObtained += parseFloat(marks);
              }
            }
          }
        });
        if (validMarks) {
          objectForAnswer.totalMarksObtained = totalMarksObtained;
          this.studentAnswersBackdated.push(objectForAnswer);
        }
      });

      try {
        if (this.marksErrors.length > 0) {
          this.showErrors = true;
          this.studentAnswersBackdated = [];
        } else if (this.studentAnswersBackdated.length > 0) {
          this.validateTotalMarks();

          if (this.marksErrors.length > 0) {
            this.showErrors = true;
            this.studentAnswersBackdated = [];
          } else {
            try {
              const results = await apiV3.postRequest('/exam/bulk-save-or-update', {
                backdatedAnswers: this.studentAnswersBackdated
              });
              showStatus("Marks given successfully", 2000, "success", this);
              await this.executeTestProcesses();
              console.log('results', results);
              this.studentAnswersBackdated = [];
              this.questionWiseMarks = [];
            } catch (error) {
              console.error("Error while saving marks:", error);
              showStatus("Failed to save marks, please try again.", 3000, "error", this);
            }
          }
        } else {
          showStatus("Make changes in marks first", 3000, "warning", this);
        }
      } catch (error) {
        console.error('Error saving backdated answers:', error);
      }
    },

    validateTotalMarks() {
      this.studentAnswersBackdated = this.studentAnswersBackdated.filter(studentMarks => {
        console.log(
          'studentMarks.totalMarksObtained',
          studentMarks.totalMarksObtained,
          Number(this.test.data?.totalMarks)
        );

        if (Number(studentMarks.totalMarksObtained) > Number(this.test.data?.totalMarks)) {
          this.marksErrors.push(
            `Marks for student: ${studentMarks.prnNumber || studentMarks.rollNumber} cannot be greater than total marks of exam which are ${this.test.data?.totalMarks}. Obtained: ${studentMarks.totalMarksObtained}`
          );
          return false; // Exclude invalid entries from the array
        }

        return true; // Keep valid entries in the array
      });
    },

    async fetchTest() {
      try {
        this.test = await apiV3.postRequest('/exam/getExamById', { testId: this.testId });
        // console.log('this.test', this.test.data);
        const objForOverall = {
          assignedStudents: this.test.data?.allowedStudents?.length,
          totalMarks: this.test.data?.totalMarks,
          passingMarks: this.test.data?.passingMarks,
          appearedStudents: null,
          totalStudentMarks: 0,
          passedStudents: null,
          failedStudents: null,
          aboveThreshold: null
        }
        this.overAllAnalysis.push(objForOverall)
      } catch (error) {
        console.error('error', error);
      }
    },

    async fetchTestAnswers() {
      console.log('hereeee');
      this.studentIds = this.studentsForTest?.map(student => student.uId) || [];

      try {
        let answersResponse = [];
        try {
          answersResponse = await apiV3.postRequest('/exam/getAnswersByStudentsAndExam', {
            studentIds: this.studentIds,
            examId: this.testId
          });
          console.log('hereeee2');
        } catch (error) {
          console.warn('Error fetching student answers:', error);
          if (error.response?.status === 404) {
            answersResponse = [];
          } else {
            throw error;
          }
        }
        console.log('hereeee2', answersResponse);
        this.studentAnswers = answersResponse;
        this.studentsForTest = this.studentsForTest.map(student => {
          const matchingAnswer = this.studentAnswers.find(answer => answer.studentId === student.uId);

          if (matchingAnswer) {
            const formattedAnswers = matchingAnswer.answers.reduce((acc, answerObj) => {
              if (answerObj.questionNumber && answerObj.outOf) {
                const dynamicKey = `${answerObj.questionNumber}(${answerObj.outOf})`;
                answerObj.marks = answerObj.marksObtained
                if (!student[dynamicKey]) {
                  acc[dynamicKey] = answerObj;
                }
              }
              return acc;
            }, {});

            return {
              ...student,
              obtainedMarks: student.obtainedMarks ?? matchingAnswer.totalMarksObtained,
              answers: student.answers ?? matchingAnswer.answers,
              ...formattedAnswers
            };
          }

          return student;
        });
        const { questions } = await apiV3.getRequest('/exam/questions', {
          examId: this.test.data?._id,
          role: 0
        });
        this.questions = questions;
        questions.forEach(question => {
          console.log('questions11', questions);
          const questionKey = `${question.questionNumber}(${question?.marks})`;

          if (!this.questionWiseMarksHeaders.find(header => header.value === questionKey)) {
            this.questionWiseMarksHeaders.push({
              text: questionKey,
              value: questionKey,
              align: "center",
              width: "10%"
            });
          }
        });

        // console.log('Updated questionWiseMarksHeaders:', this.questionWiseMarksHeaders);

        this.studentsForTest = this.studentsForTest.map(student => {
          const updatedAnswers = student.answers?.map(answer => {
            const question = questions.find(q => q.questionNumber === answer.questionNumber);
            return {
              ...answer,
              questionId: answer.questionId ?? question?._id
            };
          });

          const questionData = questions.reduce((acc, question) => {
            const questionKey = `${question.questionNumber}(${question.marks})`;

            if (!student[questionKey]) {
              acc[questionKey] = {
                marks: 0,
                outOf: question.marks,
                questionId: question._id,
                question: question.question,
                options: question.options,
                questionNumber: question.questionNumber
              };
            }

            return acc;
          }, {});

          return {
            ...student,
            answers: updatedAnswers || student.answers,
            ...questionData
          };
        });

        // console.log('Final studentsForTest:', this.studentsForTest);
      } catch (error) {
        console.log('hereeee3');
        console.error('Error processing student data:', error);
      }
    },

    async getStudents() {
      try {
        let FilterObject
        if (this.testSelection.prop_typeDivGrpBatch === "Division" || this.testSelection.prop_typeDivGrpBatch === "Batch") {
            FilterObject = {
                instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                department: this.testSelection.prop_department,
                courseYear: this.testSelection.prop_course,
                division: this.testSelection.prop_selectedDivision,
                subjectId: this.testSelection.prop_selectedSubject.subjectId
            }
            if (this.testSelection.prop_typeDivGrpBatch === "Batch") {
                FilterObject.batch = this.testSelection.prop_selectedBatch;
            }

            this.studentsForTest =
                await this.semesterUserRepositoryInstance.getSemesterUsersOfASubjectOfADivision(
                    FilterObject
                );
        } else if (this.testSelection.prop_typeDivGrpBatch === "Group") {
            FilterObject = {
                instituteId: this.selectedInstitute,
                semId: this.selectedSemester.semId,
                department: this.testSelection.prop_department,
                courseYear: this.testSelection.prop_course,
                subjectId: this.testSelection.prop_selectedSubject.subjectId,
                groupId: this.testSelection.prop_selectedGroup.groupId
            }
            this.studentsForTest =
                await this.semesterUserRepositoryInstance.getSemesterUsersOfASubjectOfAGroup(
                    FilterObject
                );
        }
      } catch (error) {
        console.error('error', error);
        this.studentsForTest = [];
      }
    },

    async getUsersDetails() {
      try {
        const uIds = this.studentsForTest.map((item) => item.uId);
        // console.log('this.studentsForTest', this.studentsForTest);
        const userData = await this.userRepositoryInstance.getUsers({ uIds });
        const userDetailsMap = new Map(
        userData.map((user) => [user.uId, user])
        );
        this.allowedStudents = this.studentsForTest.map(student => {
          const allowedStu = this.test.data?.allowedStudents?.find(allowed => allowed.uId === student.uId);
          const studentDetails = userDetailsMap.get(student.uId) || {};
          // console.log('studentDetails', studentDetails);
          const studentData = {
            ...studentDetails,
            uId: student.uId,
            rollNumber: student.rollNumber,
            prnNumber: studentDetails.collegePRNNo || null,
            examSeatNumber: studentDetails.examSeatNumber || null,
            studentName: `${studentDetails.firstName || ""} ${studentDetails.lastName || ""}`.trim()
          };
          if (allowedStu) {
            studentData.reattempt = allowedStu.reattempt;
          }
          const updatedStudent = { ...student, ...studentData };
          this.studentsForTest = this.studentsForTest.map(s => {
            if (s.uId === student.uId) {
              return updatedStudent;
            }
            return s;
          });
          return studentData;
        });
      } catch (error) {
          console.error('error', error);
      }
    }
  }
};
</script>

<style src="./onlineTestStudentMarks.css"></style>
